import { Controller } from "@hotwired/stimulus"

// Máscara automática para CPF: 000.000.000-00
export default class extends Controller {
  connect() {
    const input = this._input()
    input.addEventListener("input", this._mask)
    if (input.value) this._apply(input)
  }

  disconnect() {
    this._input().removeEventListener("input", this._mask)
  }

  _mask = (e) => this._apply(e.target)

  _apply(input) {
    let v = input.value.replace(/\D/g, "").slice(0, 11)
    if (v.length > 9) {
      v = `${v.slice(0, 3)}.${v.slice(3, 6)}.${v.slice(6, 9)}-${v.slice(9)}`
    } else if (v.length > 6) {
      v = `${v.slice(0, 3)}.${v.slice(3, 6)}.${v.slice(6)}`
    } else if (v.length > 3) {
      v = `${v.slice(0, 3)}.${v.slice(3)}`
    }
    input.value = v
  }

  _input() {
    return this.element.tagName === "INPUT" ? this.element : this.element.querySelector("input")
  }
}
